<template>
	<div class="page-content signage egl-dialog-elm">
		<h1 class="page-title">{{ $locale("setting.customDisplay.title")}}</h1>
		<p>{{ $locale("setting.customDisplay.title") + "URL" }}</p>
		<p>{{form.url}}</p>
		<el-form class="rule-form" :model="form" ref="signageForm">
			<el-row>
				<el-col :span="10">
					<el-form-item prop="alertMessage">
						<span slot="label">
							{{$locale('signage.notification')}}
							<span style="font-size: 12px">{{$locale("signage.notification.tips")}}</span>
						</span>
						<el-input v-model="form.alertMessage" />
					</el-form-item>
				</el-col>
			</el-row>
      <el-row :gutter="20" class="dialog-footer" style="margin-top: 89px;">
          <el-col :span="24">
            <el-button class="egl-btn-yellow" @click="save_fn">{{$locale("global.confirm")}}</el-button>
          </el-col>
        </el-row>
		</el-form>
	</div>
</template>
<script>
import { getKitchenDetailService, saveKitchenDetail } from "@/helpers/service/api/customDisplay";
import countDownAlert from "@/utils/countDownAlert";
export default {
  data() {
    return {
      form: {
        id: "",
        url: "",
        alertMessage: ""
      }
    };
  },
  methods: {
    getKitchenDetail_fn() {
      getKitchenDetailService({
        cinemaId: window.localStorage.getItem("cinemaId")
      }).then(res => {
        if (res.success) {
          this.form = res.data;
        }
      });
    },
    save_fn() {
      saveKitchenDetail(this.form).then(res => {
        if (res.success) {
          countDownAlert({
            content: this.$locale("global.updateSuccessfully"),
            callback: () => {
              this.getKitchenDetail_fn();
            }
          });
        }
      });
    }
  },
  created() {
    this.getKitchenDetail_fn();
  }
};
</script>